import ScannerConfigurationForm from './ScannerConfigurationForm';

export default ScannerConfigurationForm;
